import { CategoriaFiltroDTO, TagDTO } from "@DTOS";

export namespace EtiquetasAcciones {
    export class ObtenerTodo {
        static readonly type = "[Etiquetas] Obtener todo";
    }

    export class ObtenerCategorias {
        static readonly type = "[Etiquetas] Obtener categorias";
        public nombres: string[];
        constructor(...nombres: string[]) {
            this.nombres = nombres;
        }
    }

    export class ObtenerCategoriasRestantes {
        static readonly type = "[Etiquetas] Obtener categorias";
        public nombres: string[];
        constructor(...nombres: string[]) {
            this.nombres = nombres;
        }
    }

    export class ObtenerTagsPorCategorias {
        static readonly type = "[Etiquetas] Obtener etiquetas por categoria";
        public nombres: string[];
        constructor(...nombres: string[]) {
            this.nombres = nombres;
        }
    }

    export class ObtenerTagsAutocomplete {
        static readonly type = "[Etiquetas] Obtener etiquetas autocomplete";
        constructor(public nombre: string) {}
    }

    export class ObtenerTagInfo {
        static readonly type = "[Etiquetas] Obtener informacion etiqueta";
        constructor(public tag: TagDTO) {}
    }

    export class AgregarCategoria {
        static readonly type = "[Etiquetas] Agregar categoria";
        constructor(public categoriaFiltro: CategoriaFiltroDTO) {}
    }

    export class AgregarTag {
        static readonly type = "[Etiquetas] Agregar etiqueta";
        constructor(public etiqueta: TagDTO) {}
    }

    export class ModificarTag {
        static readonly type = "[Etiquetas] Modificar etiqueta";
        constructor(public etiqueta: TagDTO) {}
    }

    export class ReiniciarEstadoAccion {
        static readonly type = "[Etiquetas] Reiniciar estado accion";
    }

    export class ReiniciarEtiquetaInfo {
        static readonly type = "[Etiquetas] Reiniciar informacion etiquetas";
    }

    export class ReiniciarCategoriasSeleccionadas {
        static readonly type = "[Etiquetas] Reiniciar categorias seleccionadas";
    }

    export class PedirEntidades {
        static readonly type = "[Etiquetas] Pedir entidades";
        constructor(public accion: new (etiquetas: TagDTO[]) => any) {}
    }
}
